// Redux form main form initial values

import cloneDeep from 'lodash/cloneDeep';
import { BY_VENUE_CODE } from './venueSearchTypes';

const values = {
  venue: '',
  venueSearchTypeRadio: BY_VENUE_CODE,
  facilityCode: '',
  venueCode: '',
  manualVenueName: '',
  manualVenueAddress1: '',
  manualVenueCity: '',
  manualVenueState: '',
  manualVenueZip: '',
  manualVenueCountry: 'US',
  eventTypeRadio: '',
  eventTypeSelect: '',
  eventName: '',
  eventFrequencyField: 'continuous',
  eventDates: [],
  daysOfWeekField: [],
  eventDateRange: {
    startDate: null,
    endDate: null,
  },
  venueMunicipalityCode: '',
  federalEntity: '',
  kentuckyStateEntity: '',
  generalLiabilityCoverage: '1000000',
  eventDailyGuests: '',
  eventPerformers: 'no',
  eventPerformersCount: '0',
  eventGoods: '0',
  eventFood: '0',
  eventExhibition: '0',
  performersList: null,
  goodsVendorsList: null,
  foodVendorsList: null,
  exhibitorsList: null,
  performersFrequency: '',
  goodsVendorsFrequency: '',
  foodVendorsFrequency: '',
  exhibitorsFrequency: '',
  insuredRenter: 'Person',
  contactSame: 'yes',
  payeeSame: 'yes',
  payeeRenter: 'Person',
  insuredFirstName: '',
  insuredLastName: '',
  insuredCompany: '',
  insuredCompanyType: 'Individual',
  jointVentureType: 'Joint Venture Corporation',
  insuredAddress: '',
  insuredCity: '',
  insuredState: '',
  insuredZip: '',
  insuredCountry: 'US',

  contactPhone: '',
  contactEmail: '',
  contactRenter: 'Person',
  contactFirstName: '',
  contactLastName: '',
  contactCompany: '',
  contactAddress: '',
  contactCity: '',
  contactState: '',
  contactZip: '',
  contactCountry: 'US',

  payeeCardNum: '',
  payeeCardName: '',
  payeeFirstName: '',
  payeeLastName: '',
  payeeCompany: '',
  payeeAddress: '',
  payeeCity: '',
  payeeState: '',
  payeeZip: '',
  payeeCountry: 'US',

  ACPersonalProperty: false,
  ACHostLiquor: true,
  ACPersonalAndAdvertisingLimit: true,
  ACProductsAndCompletedOperations: true,
  ACSellingLiquor: false,
  ACTerrorism: true,
  ACDamageToRentedProperty: false,
};

export const insuredInfoInitialValues = {
  insuredRenter: 'Person',
  contactSame: '1',
  payeeSame: 'Yes',
  payeeRenter: 'Person',
  insuredFirstName: '',
  insuredLastName: '',
  insuredCompany: '',
  insuredCompanyType: 'Individual',
  insuredAddress: '',
  insuredAddress2: '',
  insuredCity: '',
  insuredState: '',
  insuredZip: '',
  insuredCountry: 'US',

  contactPhone: '',
  contactEmail: '',
  contactRenter: 'Person',
  contactFirstName: '',
  contactLastName: '',

  payeeCardNum: '',
  payeeCardName: '',
  payeeFirstName: '',
  payeeLastName: '',
  payeeCompany: '',
  payeeAddress: '',
  payeeAddress2: '',
  payeeCity: '',
  payeeState: '',
  payeeZip: '',
  payeeCountry: 'US',
  payeeCardCVV: '',
  payeeCardExp: '',
};

const initialFormValues = () => cloneDeep(values);

export default initialFormValues;
